export type PollTask = (signal: AbortSignal) => Promise<void>;

export class Poller {
  private timer: number | null = null;
  private controller: AbortController | null = null;
  private generation = 0;
  private active = false;

  constructor(
    private readonly intervalMs: number,
    private readonly task: PollTask,
  ) {}

  get isRunning(): boolean {
    return this.active;
  }

  start(): void {
    if (this.active) return;
    this.active = true;
    const generation = ++this.generation;
    void this.run(generation);
  }

  stop(): void {
    this.active = false;
    this.generation += 1;
    if (this.timer !== null) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    this.controller?.abort();
    this.controller = null;
  }

  /** Ejecuta el ciclo ahora mismo, sin esperar el siguiente intervalo. */
  runNow(): void {
    if (!this.active) return;
    this.generation += 1;
    const generation = this.generation;
    if (this.timer !== null) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    this.controller?.abort();
    this.controller = null;
    void this.run(generation);
  }

  private async run(generation: number): Promise<void> {
    if (!this.active || generation !== this.generation) return;
    const controller = new AbortController();
    this.controller = controller;
    try {
      await this.task(controller.signal);
    } catch (error) {
      console.error("Error inesperado en el ciclo de polling", error);
    } finally {
      if (this.controller === controller) this.controller = null;
      if (this.active && generation === this.generation) {
        this.timer = window.setTimeout(() => {
          this.timer = null;
          void this.run(generation);
        }, this.intervalMs);
      }
    }
  }
}
